module.exports = __webpack_public_path__ + "zw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/zw.svg
// module id = 1155
// module chunks = 0